import React, { useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { ContextData } from '../../../../context/Context';
import PersonIcon from '@mui/icons-material/Person';
import {
  Typography
} from "@mui/material";
import baseUrl from "../../../../BaseURL";
import { toast } from "react-toastify";
import PreCardShow from './PreCardShow';




const IDCardShow = (props) => {



  const {accesstoken,Person,Refresh,setRefresh,issuance,Dep_and_post,firstSlot,secondSlot,profileData,setProfileData,profileData2,setProfileData2} = React.useContext(ContextData)
  const [error, setError] = useState(null);


  const HandleApprove = async (token) =>{


    try {
      const response = await axios.put(`${baseUrl}/auth/Verified`,{token},{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }}).then(res=>{
               toast.success(res.data)
               setRefresh(!Refresh)
        })

       } catch (err) {
       if(err) console.log(err.message)
     //  setLoader(false)
       }

  }




  useEffect(() => {



    const fetchProfileData = async () => {

      setProfileData("get")


         if(firstSlot !== ""){

         try {
        const response = await axios.get(`${baseUrl}/auth/get_member_data_pageID_card/${firstSlot}`, {
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            'authorization': `Bearer ${accesstoken !== null && accesstoken}`
          }
        });
        setProfileData(response.data[0]);
      } catch (error) {
        setError("Error fetching profile data");
      }


      }


        if(secondSlot !== ""){

         try {
        const response = await axios.get(`${baseUrl}/auth/get_member_data_pageID_card/${secondSlot}`, {
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            'authorization': `Bearer ${accesstoken !== null && accesstoken}`
          }
        });
        setProfileData2(response.data[0]);
      } catch (error) {
        setError("Error fetching profile data")
      }


      }

    };

    fetchProfileData();


  },[Refresh,firstSlot,secondSlot]);


  if (!firstSlot && !secondSlot) return <div className="fin-card-empty"><span aria-hidden="true">▤</span><h3>Prepare your print sheet</h3><p>Select two members from the list. Each selected member gets a preview and a details editor.</p></div>;

  if (error) {
    return <Typography variant="h6">{error}</Typography>;
  }


  if (!profileData) {

      if(props.vr === "vr"){
        return <Typography variant="h6">Click name to load the profile</Typography>;
      }else{
        return <Typography variant="h6">Click to Fetch</Typography>;
      }

  }




  return (
    <>
     {
      profileData === "get" ?  <div> <p>Loading new data</p> </div> :
      <>



{/* Preview Card Data for update before print */}
{
  firstSlot !== "" &&
<PreCardShow
profileData = {profileData === null ? "" : profileData}
Slot="First Slot"
/>
}

{
  secondSlot !== "" &&
<PreCardShow
profileData = {profileData2 === null ? "" : profileData2}
Slot="Second Slot"
/>
}
      </>
     }

    </>
  );
};

export default IDCardShow;


// get_data_adminuse